export enum TipoAcessoAcademy {
    CODIGO_B2C = "B2C",
    CODIGO_B2B = "B2B",
    CODIGO_COMERCIAL = "COM",

    DESCRICAO_B2C = "HUB",
    DESCRICAO_B2B = "EMPRESAS",
    DESCRICAO_COMERCIAL = "COMERCIAL",
}